import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface ClientAppAccessResponse {
  contactsIds: number[];
}

export interface SetClientAppAccessRequest {
  contactsIds: number[];
}

export const CLIENT_APP_ACCESS_CHANGED = 'CLIENT_APP_ACCESS_CHANGED';

export interface ClientAppAccessChangedPayload {
  projectId: number;
}

export function useClientAppAccessService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const getAccessPersonIds = async (projectId: number): Promise<number[]> => {
    const response = await nekstApi.get(`/projects/${projectId}/clientappaccess`) as ClientAppAccessResponse;
    return response.contactsIds;
  };

  const setAccess = async (projectId: number, personIds: number[]): Promise<void> => {
    await nekstApi.post(`/projects/${projectId}/clientappaccess`, {
      contactsIds: personIds,
    } as SetClientAppAccessRequest);
    eventsPublisher.publish(CLIENT_APP_ACCESS_CHANGED, { projectId } as ClientAppAccessChangedPayload);
  };

  return {
    getAccessPersonIds,
    setAccess,
  };
}
